import { events } from '../../../test.data';
import Button from '../../button/v2/button';
import EventInfoCardContainer from '../../containers/event-info-card.container';
import ExternalLinkWrapper from '../../utility/external-link-wrapper';
import Card from '../card';
import HeaderInfoCard from './info-card/header.info-card';
import { styles } from './info-card/styles';

type Props = {
  eventId: string;
  close: Function;
};

export default function EventInfoCard({ eventId, close }: Props) {
  const event = events.find((c) => c.id === eventId);

  return (
    <>
      {event && (
        <Card className={styles.container}>
          <Card.Header className={styles.header}>
            <HeaderInfoCard title={event.title || ''} close={close} />
          </Card.Header>
          <Card.Body className={styles.body}>
            <EventInfoCardContainer event={event} />
          </Card.Body>
          <Card.Footer className={styles.footer}>
            <ExternalLinkWrapper className="w-full" link={event.linkToTickets}>
              <Button rightIcon="external-link" width="full">
                Buy Tickets
              </Button>
            </ExternalLinkWrapper>
          </Card.Footer>
        </Card>
      )}
    </>
  );
}
